<div class="close-icon" mat-button (click)="dialogRef.close()"></div>
<div>
  <h2 mat-dialog-title style="font-family: Roboto, 'Helvetica Neue', sans-serif;">Select Mapping Template</h2>
  <mat-dialog-content>
    <p-table [value]="mapppingTemplates"
             [rows]="100"
             [style]="{'margin-top':'10px'}"
             [resizableColumns]="true"
             [reorderableColumns]="true"
             dataKey="id"
             #dashboardTable>

      <ng-template pTemplate="header">
        <tr>
          <th>
            Name</th><th style="width: 5em"></th></tr>

      </ng-template>

      <ng-template pTemplate="body" let-rowData let-expanded="expanded" let-columns="columns">
        <tr [pRowToggler]="rowData">
          <td (click)="selectMappingTemplate(rowData)">
            {{rowData.name}}
          </td>
          <td>
            <i class="pi pi-plus" (click)="selectMappingTemplate(rowData)"></i>
          </td>
        </tr>
      </ng-template>



    </p-table>
  </mat-dialog-content>
</div>
